import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateDifference',
  standalone: false
})
export class DateDifferencePipe implements PipeTransform {
  transform(date: Date): string {
    if (date) {
      let diff = Math.round((Date.now() - Date.parse(date.toString())) / 1000 / 60);
      if (diff < 1) return 'Now';
      if (diff == 1) return '1 minute ago';
      if (diff > 1 && diff < 60) return diff + ' minutes ago';

      diff = Math.round(diff / 60);
      if (diff == 1) return '1 hour ago';
      if (diff > 1 && diff < 24) return diff + ' hours ago';

      diff = Math.round(diff / 24);
      if (diff == 1) return '1 day ago';
      if (diff > 1 && diff < 30) return diff + ' days ago';

      diff = Math.round(diff / 30);
      if (diff == 1) return '1 month ago';
      if (diff > 1 && diff < 12) return diff + ' months ago';

      diff = Math.round(diff / 12);
      if (diff == 1) return '1 year ago';
      if (diff > 1) return diff + ' years ago';
    }
    return 'never';
  }
}
